module.exports = __webpack_public_path__ + "static/media/shipping.ab2d4693.svg";